module.exports = __webpack_public_path__ + "static/media/execute_error_exams.ecb92904.png";